export const asyncNFTs = [
  {
    id: 'async-83',
    name: 'Async Blueprints #83',
    image: 'https://ipfs.io/ipfs/QmPMxKezdicRL73p6KZ6wh5LBN3rLUaaTYSGqsP967k9Cm',
    price: '0.04 ETH'
  },
  {
    id: 'async-18754',
    name: 'Async Blueprints #18754',
    image: 'https://ipfs.io/ipfs/QmedfHyAA3JcPFW2sThcVQe6oEhVP15fCc9QYcTEJM5nMD',
    price: '0.03 ETH'
  },
  {
    id: 'async-81',
    name: 'Async Blueprints #81',
    image: 'https://ipfs.io/ipfs/QmRJpAK5CSpgLFvNEMwys8mqqC4LWKpNVdJ1TxecKHSfit',
    price: '0.05 ETH'
  },
  {
    id: 'async-19243',
    name: 'Async Blueprints #19243',
    image: 'https://ipfs.io/ipfs/QmPn3rYmGMmD5SLvTTKKt4g6qvAGxU1woa9V1PA7fQbT6C',
    price: '0.02 ETH'
  },
  {
    id: 'async-38926',
    name: 'Async Blueprints #38926',
    image: 'https://ipfs.io/ipfs/QmQWfwh7wVT9SZfcVxwc9BqZE4AJLYA3VMUuDwVcLoPGGy',
    price: '0.06 ETH'
  },
  {
    id: 'async-3281',
    name: 'Async Blueprints #3281',
    image: 'https://ipfs.io/ipfs/QmZY4Af3YaoAzXh5N1LHGGLrQE8svurFkuKKxGaPCX4S2Q',
    price: '0.03 ETH'
  },
  {
    id: 'async-18752',
    name: 'Async Blueprints #18752',
    image: 'https://ipfs.io/ipfs/QmWxt2zjPU16Jm8dsFLMuQBr9dTfv3V9HumG8PhkktdH7v',
    price: '0.03 ETH'
  },
    
  {
    id: 'async-34529',
    name: 'Async Blueprints #34529',
    image: 'https://ipfs.io/ipfs/QmdBxWW1uphfe2FvXxvw8i5SjCLxwefmS9wK6Vnj1wUDDU',
    price: '0.04 ETH'
  },
  {
    id: 'async-34515',
    name: 'Async Blueprints #34515',
    image: 'https://ipfs.io/ipfs/QmQRPH8u4xdhZsqLArWKRCe4eJhK2Pp6PC4MEPFmUfihoW',
    price: '0.03 ETH'
  },
  {
    id: 'async-34514',
    name: 'Async Blueprints #34514',
    image: 'https://ipfs.io/ipfs/QmW2a1WgEERmMqsCUUMdsjSw9q3gfY5fTEcxCEGqJ16kRv',
    price: '0.05 ETH'
  },
  {
    id: 'async-34508',
    name: 'Async Blueprints #34508',
    image: 'https://ipfs.io/ipfs/QmfQoG4D8bVxxeJGSE4vmKKLm5HASnZ16EaBbUndKfqQQo',
    price: '0.02 ETH'
  },
  {
    id: 'async-34507',
    name: 'Async Blueprints #34507',
    image: 'https://ipfs.io/ipfs/QmRQhwTHkK1C2u1eTUK7UQkveNo8zXavCxQdk8DGGBGpH5',
    price: '0.06 ETH'
  },
  {
    id: 'async-34505',
    name: 'Async Blueprints #34505',
    image: 'https://ipfs.io/ipfs/QmPmzYMKzTU7MQpsTxUJ7eGX3HYj9skMvaih1nDTPXyp2r',
    price: '0.04 ETH'
  },
  {
    id: 'async-34506',
    name: 'Async Blueprints #34506',
    image: 'https://ipfs.io/ipfs/QmVhZ9aqZ16if6sEujTfMYWxbMhFVHYnYf2QiN8aoTx6DM',
    price: '0.03 ETH'
  },
  {
    id: 'async-37661',
    name: 'Async Blueprints #37661',
    image: 'https://ipfs.io/ipfs/Qme5mi6wGghb2zby8t5JQWHKP56q9gU7qYAtK7bxwCQKFt',
    price: '0.05 ETH'
  }




];